module.exports = __webpack_public_path__ + "static/media/3targets.092b9c3d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/layers/3targets.png
// module id = 165
// module chunks = 0